import { Injectable } from '@angular/core';
import { BlockSettings } from '@app/core/models';
import { BehaviorSubject, Subject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

export enum MenuState {
  OPEN = 0,
  CLOSE = 1,
}

@Injectable()
export class MainMenuService {
  settings = new BehaviorSubject<BlockSettings>(null);
  private _menuStateVal = MenuState.CLOSE;
  private _menuState = new Subject<MenuState>();
  public menuState = this._menuState
    .asObservable()
    .pipe(distinctUntilChanged());

  menuStateVal(): MenuState {
    return this._menuStateVal;
  }

  close() {
    this._menuState.next(MenuState.CLOSE);
    this._menuStateVal = MenuState.CLOSE;
  }

  open() {
    this._menuState.next(MenuState.OPEN);
    this._menuStateVal = MenuState.OPEN;
  }

  updateSettings(settings?: BlockSettings) {
    this.settings.next(settings);
  }
}
